var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.blur)?_c('div',{staticClass:"row justify-content-center untranslate-content"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg-9 col-md-10 col-sm-12"},[_c('div',{staticClass:"content-blur"})])
}]

export { render, staticRenderFns }